import { SubmissionState } from "../interface/SubmissionInterface";
import { addTriggeredEvent } from './UserActions';
import { authHeader, authHeader_ForPost, authHeader_ForFileUpload } from '../javascript/auth-header';

export function loadSubmissionHistory(display_id) {
    return dispatch => {
        let url = "/IRISReportsMicroservice/api/Submission/submission_history/" + display_id;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "SUBMISSION_HISTORY",
                    payload: json
                });
            });
    };
}

export function uploadFile(userInfo, file, fileType, msg) {
    return dispatch => {
        let x: SubmissionState = { fileStatus: "upload started", StepsCompleted:0 };
        dispatch({
            type: "UPLOAD_STARTED",
            payload: x
        })
        dispatch(logSubmissionAttempt(userInfo, file, fileType, msg));
    }
}


function postFileUpload(userInfo, file, fileType, submission_id, msg) {
    return dispatch => {
        var headers = authHeader_ForFileUpload();

        var data = new FormData();
        data.append("files", file)
        data.append("display_id", userInfo.display_id);
        data.append("fileType", fileType);
        data.append("submit_university", userInfo.university);
        data.append("submission_id", submission_id);
        data.append("msg", msg);

        let url = '/IRISReportsMicroservice/api/Submission/upload_file'

        const options = {
            method: 'POST',
            headers: headers,
            body: data
        }

        //delete options.headers['Content-Type'];
        fetch(url, options)
            .then(response => {
                if (response == undefined || response.status == 502) {
                    dispatch(addTriggeredEvent("Unsuccessful File Upload", userInfo.username, userInfo.display_id, "User failed to upload the " + file.name));
                    return "error";
                }
                else
                    return response.json();
            })
            .then(json => {
                //var submission_id = json;
                var result = json;
                if (result == "error") {
                    dispatch(addTriggeredEvent("Unsuccessful File Upload", userInfo.username, userInfo.display_id, "User failed to upload the " + file.name +" because of file upload error"));
                    dispatch({
                        type: "FILE_FORMAT_ERROR",
                        payload: "file upload error"
                    });
                }
                else if (result == "file-mismatch") {
                    dispatch(addTriggeredEvent("Unsuccessful File Upload", userInfo.username, userInfo.display_id, "User failed to upload the " + file.name + " because of file upload error"));
                    dispatch({
                        type: "FILE_FORMAT_ERROR",
                        payload: "incorrect file format"
                    });
                }
                else if (result.startsWith("mismatch")) {
                    dispatch(addTriggeredEvent("Unsuccessful File Upload", userInfo.username, userInfo.display_id, "User failed to upload the " + file.name + " because of incorrect file format"));
                    dispatch({
                        type: "COLUMN_MISMATCH",
                        payload: result
                    });
                } else {
                    dispatch({
                        type: "UPLOAD_COMPLETE",
                        payload: "upload complete"
                    });
                    dispatch({
                        type: "SUBMISSION_ID",
                        payload: submission_id
                    });
                    dispatch(addTriggeredEvent("Successful File Upload", userInfo.username, userInfo.display_id, "User successfully uploaded the "+ file.name));
                    dispatch(logSubmissionDetail(userInfo, file, fileType, submission_id));

                    dispatch(callCleanupFunctions(file.name, fileType, userInfo.display_id, submission_id));

                    var headers = authHeader_ForPost();
                    let url = '/IRISReportsMicroservice/api/Submission/confirm'
                    fetch(url, {
                        method: 'POST',
                        headers: headers,
                        body: JSON.stringify({
                            "display_id": userInfo.display_id,
                            "submit_file_name": file.name,
                            "file_type": fileType
                        })
                    }).
                        then(response => {
                            return response.json();
                        })
                        .then(json => {
                            var result = json;
                            dispatch({
                                type: "FILE_NAME_STAMPED",
                                payload: result
                            });
                        })
                  }
            })
    }

}

function callCleanupFunctions(fileName, fileType, display_id, submission_id) {
    return dispatch => {
        if (fileType == "vendor" || fileType == "subaward") {
            //Fix Spending- do this first AND THEN get summary
            //1. fix spending
            //2. pre summary
            //3. dupes
            //4. dupes b
            //5. abv expansion
            //6. truncation

            dispatch(fixTheStuff(fileType, display_id, submission_id, fileName))
        }
        else if (fileType == "awardidentity") {
            //Fix Spending- do this first AND THEN get summary
            //1. fix spending
            //2. pre summary
            //3. dupes
            //4. dupes b

            dispatch(fixTheStuff_AwardIdentity(fileType, display_id, submission_id, fileName))
        }
        else {
            dispatch(fixTheStuff_others(fileType, display_id, submission_id, fileName))
            //1. pre summary
            //2. dupes
            //3. dupes b
        }
    }
}


function fixTheStuff_AwardIdentity(fileType, display_id, submission_id, fileName) {
    return async dispatch => {
        let successResponse = await processStep("fix_spending", fileType, display_id, submission_id);
        dispatch({
            type: 'FIX_SPENDING',
            payload: successResponse
        });
        successResponse = await stepSummary("get_fix_spending", fileType, display_id, submission_id);
        dispatch({
            type: 'FIX_SPENDING_SUMMARY',
            payload: successResponse
        });

        successResponse = await CSVSummary(fileType, display_id, submission_id);
        dispatch({
            type: 'CSV_SUMMARY_PRE',
            payload: successResponse
        });

        successResponse = await processStep("remove_dupes", fileType, display_id, submission_id);
        dispatch({
            type: 'REMOVE_DUPES',
            payload: successResponse
        });
        successResponse = await stepSummary("dupes_summary", fileType, display_id, submission_id);
        dispatch({
            type: 'DUPES_SUMMARY',
            payload: successResponse
        });

        successResponse = await processStep("remove_dupes_b", fileType, display_id, submission_id);
        dispatch({
            type: 'REMOVE_DUPES_b',
            payload: successResponse
        });
        successResponse = await stepSummary("dupes_summary_b", fileType, display_id, submission_id);
        dispatch({
            type: 'DUPES_SUMMARY_b',
            payload: successResponse
        });
    }
}

function fixTheStuff_others(fileType, display_id, submission_id, fileName) {
    return async dispatch => {
        let successResponse = await CSVSummary(fileType, display_id, submission_id);
        dispatch({
            type: 'CSV_SUMMARY_PRE',
            payload: successResponse
        });

        successResponse = await processStep("remove_dupes", fileType, display_id, submission_id);
        dispatch({
            type: 'REMOVE_DUPES',
            payload: successResponse
        });
        successResponse = await stepSummary("dupes_summary", fileType, display_id, submission_id);
        dispatch({
            type: 'DUPES_SUMMARY',
            payload: successResponse
        });

        successResponse = await processStep("remove_dupes_b", fileType, display_id, submission_id);
        dispatch({
            type: 'REMOVE_DUPES_b',
            payload: successResponse
        });
        successResponse = await stepSummary("dupes_summary_b", fileType, display_id, submission_id);
        dispatch({
            type: 'DUPES_SUMMARY_b',
            payload: successResponse
        });
    }
}
function fixTheStuff(fileType, display_id, submission_id, fileName) {
    return async dispatch => {
        let successResponse = await processStep("fix_spending", fileType, display_id, submission_id);
        dispatch({
            type: 'FIX_SPENDING',
            payload: successResponse
        });
        successResponse = await stepSummary("get_fix_spending", fileType, display_id, submission_id);
        dispatch({
            type: 'FIX_SPENDING_SUMMARY',
            payload: successResponse
        });

        successResponse = await CSVSummary(fileType, display_id, submission_id);
        dispatch({
            type: 'CSV_SUMMARY_PRE',
            payload: successResponse
        });

        successResponse = await processStep("remove_dupes", fileType, display_id, submission_id);
        dispatch({
            type: 'REMOVE_DUPES',
            payload: successResponse
        });
        successResponse = await stepSummary("dupes_summary", fileType, display_id, submission_id);
        dispatch({
            type: 'DUPES_SUMMARY',
            payload: successResponse
        });

        successResponse = await processStep("remove_dupes_b", fileType, display_id, submission_id);
        dispatch({
            type: 'REMOVE_DUPES_b',
            payload: successResponse
        });
        successResponse = await stepSummary("dupes_summary_b", fileType, display_id, submission_id);
        dispatch({
            type: 'DUPES_SUMMARY_b',
            payload: successResponse
        });

        successResponse = await processStep("abv_expansion", fileType, display_id, submission_id);
        dispatch({
            type: 'ABV_EXPANSION',
            payload: successResponse
        });
        successResponse = await stepSummary("get_abv", fileType, display_id, submission_id);
        dispatch({
            type: 'ABV_EXPANSION_SUMMARY',
            payload: successResponse
        });

        successResponse = await truncation(fileName, fileType, display_id, submission_id);
        dispatch({
            type: "TRUNCATION_SUMMARY",
            payload: successResponse
        });
    }
}

async function processStep(methodName, fileType, display_id, submission_id) {
        var headers = authHeader_ForPost();
        let url = '/IRISReportsMicroservice/api/Submission/' + methodName
        await fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                "file_type": fileType,
                "display_id": display_id,
                "SubmissionID": submission_id
            })
        }).
            then(response => {
                return response.json();
            })
            .then(json => {
    
            })
    return "removed";    
}

async function stepSummary(methodName, fileType, display_id, submission_id) {
    var results; 
    var headers = authHeader_ForPost();
    let url = '/IRISReportsMicroservice/api/Submission/' + methodName
    await fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            "file_type": fileType,
            "display_id": display_id,
            "SubmissionID": submission_id

        })
    }).
    then(response => {
        return response.json();
    })
    .then(json => {
        results = json;
    })
    return results;                
}

async function truncation(fileName, fileType, display_id, submission_id) {
    var results;
    var methodName = "truncation_" + fileType;

    var headers = authHeader_ForPost();
    let url = '/IRISReportsMicroservice/api/Submission/' + methodName
    await fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            "submit_file_name": fileName,
            "display_id": display_id,
            "SubmissionID": submission_id
        })
    }).
    then(response => {
        return response.json();
    })
    .then(json => {
        results = json;
    })
    return results;
}



async function CSVSummary(fileType, display_id, submission_id) {
    var results;
    var headers = authHeader_ForPost();
    let url = '/IRISReportsMicroservice/api/Submission/csv_summary'
    await fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            "file_type": fileType,
            "display_id": display_id,
            "SubmissionID": submission_id

        })
    }).
    then(response => {
        return response.json();
    })
    .then(json => {
        results= json[0];
    })
    return results;
}
export function doneAction(fileType, display_id, submission_id) {
    return async dispatch => {
        dispatch({
            type: "DONE",
            payload: "processing complete"
        })
        var results = await CSVSummary(fileType, display_id, submission_id);
        dispatch({
            type: "CSV_SUMMARY_POST",
            payload: results
        })
    }
}

export function clearSubmissionState() {
    return dispatch => {
        dispatch({
            type: "UPLOAD_NOT_STARTED",
            payload: "upload not started"
        })
    }
}

export function proceed(display_id,fileType,fileName) {
    return dispatch => {
        dispatch({
            type: "CONFIRMED",
            payload: "upload confirmed"
        })
    }
}
export function cancel(display_id, submission_id, fileName, fileType) {

    return dispatch => {
        var headers = authHeader_ForPost();
        let url = '/IRISReportsMicroservice/api/Submission/cancel'
        fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                "display_id": display_id,
                "SubmissionID": submission_id,
                "submit_file_name": fileName,
                "file_type": fileType,

            })
        }).
            then(response => {
                return response.json();
            })
            .then(json => {
                dispatch({
                    type: "CANCELLED",
                    payload: "upload cancelled"
                });
            })
    }
}

function generateCSV_and_Download(rows, downloadFileName) {
    var keys = Object.keys(rows[0]);
    var text = keys.join(",");
    rows.forEach((item, index) => {
        text += "\n";

        keys.forEach((key) => {
            text += "\"" + emptyStringIfNull(item[key]) + "\"";
            text += ",";
        })

        text = text.slice(0, -1);
    });
    downloadFile(text, downloadFileName);
}

function emptyStringIfNull(value) {
    return (value !== null && value !== undefined) ? value : "";
}

// CREATE CSV - create a file!
function dupesCSVText(method_name,fileType, display_id, submission_id,downloadFileName) {
    var headers = authHeader_ForPost();
    let url = '/IRISReportsMicroservice/api/Submission/' + method_name
    fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            "file_type": fileType,
            "display_id": display_id,
            "SubmissionID": submission_id

        })
    }).
    then(response => {
        return response.json();
    })
    .then(json => {
        generateCSV_and_Download(json, downloadFileName)
    })
}

export function downloadDupesCSV_b(csvData,fileType, display_id, submission_id) {
    return dispatch => {
        dupesCSVText("dupes_csv_b", fileType, display_id, submission_id, "download_1b.csv");
    }
}

export function downloadFixSpending(csvData,fileType, display_id, submission_id) {
    return dispatch => {
        generateCSV_and_Download(csvData, "dowload_3.csv");
        //fixSpendingCSVText(csvData, "dowload_3.csv");
    }
}

export function downloadAbvExpansion(csvData,fileType, display_id, submission_id) {
    return dispatch => {
        generateCSV_and_Download(csvData, "dowload_2.csv");
        //abvCSVText(csvData, "dowload_2.csv");
    }
}
export function downloadTruncation(csvData,fileType, display_id, submission_id) {
    return dispatch => {
        generateCSV_and_Download(csvData, "dowload_4.csv");
        //truncationCSVText(csvData, "dowload_4.csv");
    }
}

export function downloadDupesCSV(csvData,fileType, display_id, submission_id) {
    return dispatch => {
        dupesCSVText("dupes_csv", fileType, display_id, submission_id, "download_1a.csv");
        //dispatch(downloadFile(text, "download_1a.csv"));
    }
}
function logSubmissionDetail(userInfo, file, fileType, submission_id) {
    return dispatch => {
        var headers = authHeader_ForPost();
        let url = '/IRISReportsMicroservice/api/Submission/submission_detail'
        fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                "SubmissionID": submission_id,
                "adminAccount": userInfo.username,
                "fileType": fileType,
                "fileName": file.name,
                "sequenceNumber": 1,
                "submissionLabel": "label",
                "optionalShortNote": "note",
                "submissionEmail": userInfo.username,
                "submissionFileSize": file.size,
                "dataDateRangeStart": "01-01-2001",
                "dataDateRangeEnd": "01-01-2001",
                "submissionUniversity": userInfo.university,
                "display_id": userInfo.display_id
            })
        }).
            then(response => {
                return response.json();
            })
            .then(json => {
                dispatch({
                    type: "SUBMISSION_DETAIL",
                    payload: "done"
                })
            })
    }
}
function logSubmissionAttempt(userInfo, file, fileType, msg) {
    return dispatch => {
        var headers = authHeader_ForPost();
        let url = '/IRISReportsMicroservice/api/Submission/submission_attempt'
        fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                "adminAccount": userInfo.username,
                "fileType": fileType,
                "fileName": file.name,
                "sequenceNumber": 1,
                "submissionLabel": "label",
                "optionalShortNote": "note",
                "submissionEmail": userInfo.username,
                "submissionFileSize": file.size,
                "submissionUniversity": userInfo.university,
                "display_id": userInfo.display_id
            })
        }).
            then(response => {
                return response.json();
            })
            .then(json => {
                var submission_id = json[0];

                dispatch(postFileUpload(userInfo, file, fileType, submission_id, msg));
            })
    }
}


export function downloadFile(text, filename) {
    var element = document.createElement('a');

    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
    return {
        type: "DOWNLOAD",
        payload: "download"
    }
}
export function get_classification_classified(display_id) {
    return dispatch => {
        var headers = authHeader();
        let url = '/IRISReportsMicroservice/api/Submission/employee_classification_classified/' + display_id;
        return fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                const result = classificationHelper(json);
                return result;
            });
    }
}
export function get_classification_unclassified(display_id) {
    return dispatch => {
        var headers = authHeader();
        let url = '/IRISReportsMicroservice/api/Submission/employee_classification_unclassified/' + display_id;
        return fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                const result = classificationHelper(json);
                return result;
            });
    }
}
function classificationHelper(data) {
    //group by job_title
    return data.reduce((acc, obj) => {
        var key = obj["job_title"];
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
    }, {});
}